// @flow
import fetchFromApiServer from '../../../service/index';

export function getDetailOfAd(productUrl){
    var url = 'WMSDetail/GetProductDetail?productUrl=' + productUrl;
    
    return {
      type:'GET_DETAIL_OF_AD',
      payload:fetchFromApiServer("GET", url)
    }
}

export function addToCart(obj){
  var url = 'WMSDetail/SetCustomerCart';
  return {
    type:'ADD_TO_CART',
    payload:fetchFromApiServer("POST", url, obj)
  }
}

export function onShareAddToCart(obj){
  var url = 'WMSDetail/SetShareCustomerCart';
  return {
    type:'ADD_TO_CART_SHARE',
    payload:fetchFromApiServer("POST", url, obj)
  }
}

export function setDelivery(obj){
  var url = 'WMSDetail/SetDeliveryAddress';
  return {
    type:'SET_DELIVERY_ADD',
    payload:fetchFromApiServer("POST", url, obj)
  }
}

export function increaseQuantity(quantity){
 
  return {
    type:'INCREASE_QUANTITY_PRODUCT',
    payload:quantity
}
}
export function decreaseQuantity(quantity){
  return {
    type:'DECREASE_QUANTITY_PRODUCT',
    payload:quantity
  }
}

export function storeDetailInfo(data){
  return {
    type:'STORE_DETAIL_INFO',
    payload:data
  }
}
    export function storeHashKey(key,deliveryKey){
    return {
      type:'STORE_HASH_KEY',
      payload:key,
      deliveryKey: deliveryKey
    }
  }
